<template>
  <div data-test-id="rating-summary">
    <div v-if="reviewsData?.rollup?.reviewCount" class="self-center">
      <base-button class="items-center gap-2 i-flex" @click="openReviews">
        <vf-rating :value="reviewsData.rollup.averageRating" />
        <span aria-hidden="true" class="text-xs lh-4 underlined">
          ({{ reviewsData.rollup.reviewCount }})
        </span>
        <span class="sr-only">
          {{
            replaceAll(
              $pluralize($t.viewNumberOfReviews, reviewsData.rollup.reviewCount),
              { reviewsCount: reviewsData.rollup.reviewCount },
            )
          }}
        </span>
      </base-button>
    </div>
    <panel-product-reviews
      class-content="md:w-128"
      v-bind="{
        data: reviewsData,
        showHeading: false,
      }"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ProductReviewsData } from '#types/components/product/reviews'

defineProps<{
  reviewsData?: ProductReviewsData
}>()

const { $gtm } = useNuxtApp()
const PanelProductReviews = createPanel('product-reviews')

const openReviews = () => {
  $gtm.push('pdpPage.onViewReviews')
  PanelProductReviews.open()
}
</script>
